const systemBanner = {
  admin: {
    enabled: 'Mostrar banner',
    level: 'Gravedad',
    level_info: 'Información',
    level_warning: 'Advertencia',
    level_critical: 'Crítico',
    template: 'Plantilla',
    template_params: 'Parámetros de la plantilla',
    template_params_hint:
      'Los valores que introduzca sustituyen los {{marcadores}} del mensaje de la plantilla seleccionada.',
    preview: 'Vista previa (idioma actual)',
  },
  validation: {
    invalid_template: 'La plantilla seleccionada ya no está disponible.',
    template_required: 'Elija una plantilla.',
    invalid_datetime: 'Introduzca una fecha y hora válidas.',
    invalid_number: 'Introduzca un número válido.',
  },
};

export default systemBanner;
